import React from 'react'
import AvatarEditor from 'react-avatar-editor'
import { styles } from './styles'
import Slider from '@material-ui/core/Slider'
import resetIcon from './../../assets/images/reset.svg'
// import Tooltip from '@material-ui/core/Tooltip'
import { withTranslation } from 'react-i18next'
import { TFunction } from 'i18next'

interface PositionProps {
  x: number
  y: number
}

interface ImageCropProps {
  t: TFunction
  imageSrc: string
  editorRef: any
  scaleValue: number
  onScaleChange: () => number
  position: PositionProps
  onPositionChange: () => PositionProps
  resetAdjustments: () => void
}

const ImageCrop = ({
  t,
  imageSrc,
  editorRef,
  scaleValue,
  onScaleChange,
  position,
  onPositionChange,
  resetAdjustments,
}: ImageCropProps) => {
  const classes = styles()

  return (
    <div>
      <div>
        <div>
          <div className={classes.cropper}>
            <button className={classes.reset} onClick={resetAdjustments}>
              <img
                src={resetIcon}
                alt={t('shared.reset')}
                className={classes.resetIcon}
              />
            </button>
            <AvatarEditor
              image={imageSrc}
              border={25}
              scale={scaleValue}
              ref={editorRef}
              onPositionChange={onPositionChange}
              position={position}
              width={464}
              height={464}
            />
            <Slider
              value={scaleValue}
              onChange={onScaleChange}
              type="range"
              aria-labelledby="continuous-slider"
              min={1}
              max={10}
              name="points"
              classes={{
                root: classes.root,
                thumb: classes.thumb,
                track: classes.track,
                rail: classes.rail,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(ImageCrop)
